import { createScheduler } from '../scheduler/scheduler';
import { timing } from '../metrics/timing';
let __TEST_ONLY_DISABLE_CACHE_GC = false;
export const __testOnlyDisableCacheGC = () => {
  __TEST_ONLY_DISABLE_CACHE_GC = true;
};
export const __testOnlyEnableCacheGC = () => {
  __TEST_ONLY_DISABLE_CACHE_GC = false;
};
export const createGCManager = ({
  nodes,
  removeNode,
  logger
}) => {
  // TODO: Configurable gc policies
  const gcScheduler = createScheduler({
    minPeriod: 15000,
    // 15s
    maxPeriod: 300000 // 5min
  });
  const collectNode = instanceKey => {
    if (!nodes.has(instanceKey)) return;
    const startTime = performance.now();
    logger === null || logger === void 0 || logger.debug('collecting node', {
      instanceKey
    });
    removeNode(instanceKey);
    timing.timeCollectNode(performance.now() - startTime);
  };
  return {
    queue: (instanceKey, period) => {
      if (!__TEST_ONLY_DISABLE_CACHE_GC) {
        gcScheduler.queue(instanceKey, period, collectNode);
      }
    },
    clear: instanceKey => {
      gcScheduler.clear(instanceKey);
    },
    getAllStatuses: () => gcScheduler.getAllStatuses()
  };
};